import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '@ems/shared';
import { emtrConstant } from '../constants/emtrConstants';
import { RuleService } from '../services/rule-service/rule.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'tr-validator',
  templateUrl: './simulator.component.html'
})
export class SimulatorComponent implements OnInit, OnDestroy {

  validatorSubMenu: any;
  isValidatorComponent = true;
  toastMsg = '';
  toastType = '';
  private toastTypeSubscription: Subscription;
  private toastMsgSubscription: Subscription;
  @ViewChild('toastMessage') msgToast: any;

  constructor(public sharedService: SharedService, private readonly ruleService: RuleService) {}

  ngOnInit() {
    this.setNavigation();

    this.toastTypeSubscription = this.ruleService.toastType.subscribe((value) => {
      this.toastType = value || '';
    });

    this.toastMsgSubscription = this.ruleService.toastMsg.subscribe((value) => {
      this.toastMsg = value || '';
      setTimeout(() => {
        if (this.msgToast) {
          this.msgToast.pushMessage(this.toastType, this.toastMsg);
        }
      }, 1);
    });
  }

  setNavigation() {
    this.validatorSubMenu = [
      {
        id: 1,
        name: emtrConstant.restrictionSimulator.restrictionSimulatorText,
        route: 'restriction-simulator'
      }
    ];
  }

  ngOnDestroy() {
    this.isValidatorComponent = false;
    if (this.toastTypeSubscription) {
      this.toastTypeSubscription.unsubscribe();
    }
    if (this.toastMsgSubscription) {
      this.toastMsgSubscription.unsubscribe();
    }
  }
}
